<template>
  <div>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div class="summary-header">
      <div class="summary-title">
        <div class="summary-icon-offers"></div>
        <div class="summary-text">{{ $t('My_offers') }}</div>
      </div>
    </div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :load-panel="{ enabled: false }"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataText')"
      class="custom-grid custom-offers"
      @cell-prepared="onCellPrepared"
      @content-ready="init"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />

      <DxStateStoring
        :enabled="true"
        type="custom"
        storage-key="OffersTable"
        :custom-load="loadState"
        :custom-save="customSave"
      />

      <DxPaging :page-size="10" />

      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="CodPresupuesto"
        :caption="$t('offerCode')"
        alignment="center"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="Titulo"
        :caption="$t('title')"
        alignment="center"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="SubTitulo"
        :caption="$t('subTitle')"
        alignment="center"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="FechaPresupuesto"
        :caption="$t('initialDate')"
        alignment="center"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        data-type="date"
        :format="$helpers.getDateFormat(company)"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="CodEstado"
        :caption="$t('status')"
        alignment="center"
        :fixed="true"
        fixed-position="right"
        :allow-header-filtering="false"
        cell-template="cellTemplateStatus"
      />

      <DxColumn
        :buttons="updatedEditButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        name="actionColumn"
      />
      <template #cellTemplateStatus="{ data }">
        <div
          :class="[
            $helpers.getStatusClass(data.data.CodEstado),
            'status-text',
          ]"
          style="text-align: center"
        >
          {{ $t(getOfferStatusKey(data.data.CodEstado)) }}
        </div>
      </template>

      <!-- <template #cellTemplateStatus="{ data }">
        <div
          :class="$helpers.getStatusClass(data.data.CodEstado)"
          style="text-align: center"
        >
          {{ $t($helpers.getStatusTextKey(data.data.Estado)) }}
        </div>
      </template> -->
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { mapState, mapActions } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import iconNewSample from '@/static/icons/ic_new_sample.svg';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: 'find',
          onClick: this.viewAtc,
        },
      ],
      // Estado de los botones de la toolbar
      toolbarFiltersState: {
        Pendientes: false,
        Rechazados: false,
        Aceptados: false,
      },
      grid: null,
      loaded: false,
    };
  },
  computed: {
    updatedEditButtons() {
      return [
        {
          icon: iconVisibility,
          onClick: this.viewAtc,
          cssClass: 'grid-button-icon',
        },
        {
          icon: iconNewSample,
          onClick: this.goToRegister,
          cssClass: 'grid-button-icon',
          visible: (e) => String(e?.row?.data?.CodEstado) !== '4',
        },
      ];
    },
    ...mapState('contact', ['company']),
  },

  // Leer de localStorage ANTES de que se pinte la grid/toolbar
  beforeMount() {
    this.loaded = false;
    const raw = localStorage.getItem('OffersTable');
    if (raw) {
      try {
        const saved = JSON.parse(raw);
        if (saved.toolbarFiltersState) {
          Object.assign(
            this.toolbarFiltersState,
            saved.toolbarFiltersState
          );
        }
      } catch (e) {
        console.warn('OffersTable corrupto en localStorage', e);
      }
    }
    this.loaded = true;
  },

  methods: {
    applyStatusFilter(codEstados) {
      const current =
        this.$store.state.OffersListFilters.selectedStatuses || [];

      const isSameFilter =
        current.length === codEstados.length &&
        current.every((c) => codEstados.includes(c));

      const newValue = isSameFilter ? [] : codEstados;

      this.setSelectedStatuses(newValue);
      this.applyCurrentFilters();
    },
    getOfferStatusKey(codEstado) {
      const map = {
        1: 'offerStatus.pending',
        2: 'offerStatus.rejected',
        3: 'offerStatus.accepted',
        4: 'offerStatus.cancelled',
      };
      return map[codEstado] ?? 'offerStatus.pending'; // o una key tipo 'common.unknown'
    },
    // Desactiva visualmente el resto de botones de estado
    resetStatusButtons(clickedEl) {
      const toolbarEl = clickedEl.closest('.dx-toolbar');
      if (!toolbarEl) return;

      toolbarEl
        .querySelectorAll('.filtrosBotones.show-icon')
        .forEach((btn) => {
          if (btn !== clickedEl) {
            btn.classList.remove('show-icon');
            btn.classList.add('hide-icon');
          }
        });
    },

    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // -------- PENDIENTES --------
      toolbarItems.push({
        name: 'Pendientes',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('offerStatus.pending'),
          icon: '././static/icons/ic_check.svg',
          width: 150,
          elementAttr: {
            class:
              'filtrosBotones ' +
              (this.toolbarFiltersState.Pendientes
                ? 'show-icon'
                : 'hide-icon'),
          },
          onClick: (e) => {
            const codEstados = [1];

            this.resetStatusButtons(e.element);

            const current =
              this.$store.state.OffersListFilters.selectedStatuses ||
              [];
            const isSameFilter =
              current.length === codEstados.length &&
              current.every((c) => codEstados.includes(c));

            this.toolbarFiltersState.Pendientes = !isSameFilter;
            this.toolbarFiltersState.Aceptados = false;
            this.toolbarFiltersState.Rechazados = false;

            e.element.classList.toggle(
              'show-icon',
              this.toolbarFiltersState.Pendientes
            );
            e.element.classList.toggle(
              'hide-icon',
              !this.toolbarFiltersState.Pendientes
            );

            this.applyStatusFilter(
              this.toolbarFiltersState.Pendientes ? codEstados : []
            );

            if (this.grid) {
              const gridState = this.grid.state();
              this.customSave(gridState);
            }
          },
        },
      });

      // -------- ACEPTADOS --------
      toolbarItems.push({
        name: 'Aceptados',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('offerStatus.accepted'),
          icon: '././static/icons/ic_check.svg',
          width: 140,
          elementAttr: {
            class:
              'filtrosBotones ' +
              (this.toolbarFiltersState.Aceptados
                ? 'show-icon'
                : 'hide-icon'),
          },
          onClick: (e) => {
            const codEstados = [3];

            this.resetStatusButtons(e.element);

            const current =
              this.$store.state.OffersListFilters.selectedStatuses ||
              [];
            const isSameFilter =
              current.length === codEstados.length &&
              current.every((c) => codEstados.includes(c));

            this.toolbarFiltersState.Aceptados = !isSameFilter;
            this.toolbarFiltersState.Pendientes = false;
            this.toolbarFiltersState.Rechazados = false;

            e.element.classList.toggle(
              'show-icon',
              this.toolbarFiltersState.Aceptados
            );
            e.element.classList.toggle(
              'hide-icon',
              !this.toolbarFiltersState.Aceptados
            );

            this.applyStatusFilter(
              this.toolbarFiltersState.Aceptados ? codEstados : []
            );

            if (this.grid) {
              const gridState = this.grid.state();
              this.customSave(gridState);
            }
          },
        },
      });
    },

    loadState() {
      const raw = localStorage.getItem('OffersTable');
      if (!raw) return null;

      const state = JSON.parse(raw);
      state.searchText = '';
      return state;
    },

    customSave(state) {
      const extendedState = {
        ...state,
        toolbarFiltersState: this.toolbarFiltersState,
      };
      localStorage.setItem(
        'OffersTable',
        JSON.stringify(extendedState)
      );
    },

    onCellPrepared(e) {
      if (e.rowType === 'data') {
        if (e.column.dataField === 'CodPresupuesto') {
          e.data.isQCF =
            e.cellElement.textContent.substring(0, 3) === 'QCF';
        }
        if (e.column.name === 'actionColumn' && e.data.isQCF) {
          e.cellElement.innerText = ' ';
        }
      }
    },

    // Guardamos la instancia del grid (nada más, para evitar bucles)
    init(e) {
      this.grid = e.component;
    },

    async viewAtc(e) {
      try {
        this.loaded = false;
        this.setSampleFetchedFromEtl(false);
        this.setLastRouteHome(false);
        this.setLastRouteGeotoolboxSamples(false);
        await this.fetchDetallesPresupuestos(
          e.row.data.CodPresupuesto
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.loaded = true;
        this.replaceCurrent({
          name: this.$t('offersDetails'),
          disabled: false,
          page: 'offersDetails',
          active: true,
        });

        this.$f7router.navigate(
          { name: 'offersDetails' },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      }
    },

    goToRegister(e) {
      this.resetData();
      this.setOfferSelected(e.row.data.CodPresupuesto);
      this.RegisterInvoice();
      this.$f7router.navigate(
        {
          name: 'SamplesRegister',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },

    ...mapActions('Offers', ['fetchDetallesPresupuestos']),
    ...mapActions('breadcrumb', ['replaceCurrent']),
    ...mapActions('samplesRegisterModule', [
      'resetData',
      'setOfferSelected',
      'RegisterInvoice',
    ]),
    ...mapActions('samples', [
      'setSampleFetchedFromEtl',
      'setLastRouteHome',
      'setLastRouteGeotoolboxSamples',
    ]),
    ...mapActions('OffersListFilters', ['setSelectedStatuses']),
    ...mapActions('filter', [
      'clearCurrentFilters',
      'applyCurrentFilters',
    ]),
  },
};
</script>

<style lang="scss">
@import './OfferListTable.styles.scss';
</style>
